import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { DEPRECATED, REQUESTED } from "constants/sensitiveData";
import { useToast } from "hooks/useToast";
import { useUpdateChatActionItemStatusMutation } from "store/apis/chat";
import { MessageResponse } from "stream-chat";
import { DefaultStreamChatGenerics } from "stream-chat-react";
import { CustomData } from "types/Models/reviewDocumentAndBalancingPayment";
import { BackendError } from "types/utils/error";

export type ActionCentreMessage = MessageResponse<DefaultStreamChatGenerics> & {
  custom_data: CustomData;
};

export const ArchiveActionCentreItemModal = ({
  message,
  groupId,
  onClose,
  onSuccess,
}: {
  message: ActionCentreMessage | null;
  groupId: string;
  onClose: () => void;
  onSuccess: () => void;
}) => {
  const [updateChatActionItemStatus, { isLoading }] =
    useUpdateChatActionItemStatusMutation();
  const { alertToast, successToast } = useToast();
  const isDeprecated = message?.card_status === DEPRECATED;

  const updateActionItemStatus = async () => {
    if (!message?.id) {
      return;
    }

    try {
      await updateChatActionItemStatus({
        groupId,
        messageId: message.id,
        payload: {
          custom_type: (message.custom_type as string) || "",
          card_status_str: isDeprecated ? REQUESTED : DEPRECATED,
        },
      }).unwrap();

      successToast({
        message: isDeprecated
          ? "Action item unarchived successfully."
          : "Action item archived successfully.",
      });
      void onSuccess();
      onClose();
    } catch (error) {
      alertToast({
        message: (error as BackendError).data?.error?.message,
      });
    }
  };

  const modalTitle = isDeprecated
    ? "Unarchive Action Item"
    : "Archive Action Item";
  const modalDescription = isDeprecated ? (
    <>
      Are you sure you want to unarchive this action item? <br />
      <br />
      It will reappear as an active item in the Action Centre widget.
    </>
  ) : (
    <>
      Are you sure you want to archive this action item? <br />
      <br /> It will be removed from the Action Centre widget, but you can view
      and unarchive it anytime from the <b>Archived</b> section in the Action
      Centre.
    </>
  );
  const buttonText = isDeprecated ? "Unarchive" : "Archive";

  if (!message) {
    return null;
  }

  return (
    <Modal.Root open onOpenChange={onClose}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{modalTitle}</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-text-body-sm t-text-text-60">
            {modalDescription}
          </div>
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button size="small">Cancel</Button>
          </Modal.RawClose>
          <Button
            customType="primary"
            size="small"
            onClick={updateActionItemStatus}
            isLoading={isLoading}
            disabled={isLoading}
          >
            {buttonText}
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
